/**
 * Gössl Theme — GSAP Animations
 * Scroll-triggered text reveals for section headings and content.
 */
(function() {
  'use strict';

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    if (typeof SplitText !== 'undefined') gsap.registerPlugin(SplitText);

    // ── Section headings (any element containing .section-header__line) ──
    // Find all heading containers by looking at the lines' parents
    var headingEls = new Set();
    document.querySelectorAll('.section-header__line').forEach(function(line) {
      headingEls.add(line.parentElement);
    });

    headingEls.forEach(function(heading) {
      var lines = heading.querySelectorAll('.section-header__line');
      var aboveFold = ScrollTrigger.isInViewport(heading, 0);
      var lineDelay = 0;

      lines.forEach(function(line, idx) {
        var isScript = line.classList.contains('section-header__line--script');

        if (isScript && typeof SplitText !== 'undefined') {
          var split = new SplitText(line, { type: 'chars' });
          gsap.set(split.chars, { autoAlpha: 0, y: 14 });

          if (aboveFold) {
            gsap.to(split.chars, {
              autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.04,
              ease: 'power2.out', delay: 0.6 + idx * 0.2
            });
          } else {
            ScrollTrigger.create({
              trigger: heading, start: 'top 85%', once: true,
              onEnter: function() {
                gsap.to(split.chars, {
                  autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.04,
                  ease: 'power2.out', delay: idx * 0.15
                });
              }
            });
          }
        } else {
          gsap.set(line, { autoAlpha: 0, y: 18 });

          if (aboveFold) {
            gsap.to(line, {
              autoAlpha: 1, y: 0, duration: 0.7, ease: 'power2.out',
              delay: 0.7 + idx * 0.2
            });
          } else {
            ScrollTrigger.create({
              trigger: heading, start: 'top 85%', once: true,
              onEnter: function() {
                gsap.to(line, {
                  autoAlpha: 1, y: 0, duration: 0.7, ease: 'power2.out',
                  delay: idx * 0.15
                });
              }
            });
          }
        }
      });

      // Also animate the ornament if present
      var ornament = heading.parentElement && heading.parentElement.querySelector('.section-header__ornament');
      if (ornament) {
        gsap.set(ornament, { autoAlpha: 0, scale: 0.8 });
        if (aboveFold) {
          gsap.to(ornament, {
            autoAlpha: 1, scale: 1, duration: 0.6, ease: 'power2.out', delay: 0.4
          });
        } else {
          ScrollTrigger.create({
            trigger: heading, start: 'top 85%', once: true,
            onEnter: function() {
              gsap.to(ornament, {
                autoAlpha: 1, scale: 1, duration: 0.6, ease: 'power2.out'
              });
            }
          });
        }
      }
    });

    // ── Collection hero heading ──
    document.querySelectorAll('.goessl-collection-hero__preheading').forEach(function(pre) {
      if (typeof SplitText !== 'undefined') {
        var split = new SplitText(pre, { type: 'chars' });
        gsap.set(split.chars, { autoAlpha: 0, y: 14 });
        gsap.to(split.chars, {
          autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.04,
          ease: 'power2.out', delay: 0.3
        });
      } else {
        gsap.set(pre, { autoAlpha: 0, y: 18 });
        gsap.to(pre, {
          autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: 0.3
        });
      }
    });

    document.querySelectorAll('.goessl-collection-hero__title').forEach(function(title) {
      gsap.set(title, { autoAlpha: 0, y: 24 });
      gsap.to(title, {
        autoAlpha: 1, y: 0, duration: 0.7, ease: 'power2.out', delay: 0.6
      });
    });

    document.querySelectorAll('.goessl-collection-hero__description').forEach(function(desc) {
      gsap.set(desc, { autoAlpha: 0, y: 16 });
      gsap.to(desc, {
        autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: 0.9
      });
    });

    // ── Product page title ──
    var productTitle = document.querySelector('.goessl-product__title');
    if (productTitle) {
      gsap.set(productTitle, { autoAlpha: 0, y: 18 });
      gsap.to(productTitle, {
        autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: 0.25
      });
    }

    // ── Newsletter CTA heading ──
    document.querySelectorAll('.newsletter-cta__heading').forEach(function(el) {
      gsap.set(el, { autoAlpha: 0, y: 20 });
      ScrollTrigger.create({
        trigger: el, start: 'top 85%', once: true,
        onEnter: function() {
          gsap.to(el, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power2.out' });
        }
      });
    });

    // ── Generic: data-animate="fade-up" ──
    document.querySelectorAll('[data-animate="fade-up"]').forEach(function(el) {
      gsap.set(el, { autoAlpha: 0, y: 24 });
      if (ScrollTrigger.isInViewport(el, 0)) {
        gsap.to(el, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: 0.4 });
      } else {
        ScrollTrigger.create({
          trigger: el, start: 'top 88%', once: true,
          onEnter: function() {
            gsap.to(el, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out' });
          }
        });
      }
    });
  }

  // Run once GSAP + plugins are ready
  function ready() {
    return typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  }
  function start() {
    function run() {
      try { init(); } catch(e) { console.warn('GSAP animations error:', e); }
      // Refresh triggers after layout settles (images, Swiper, etc.)
      setTimeout(function() { ScrollTrigger.refresh(); }, 500);
    }
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run);
    }
  }
  if (ready()) {
    start();
  } else {
    var n = 0;
    var poll = setInterval(function() {
      if (ready()) { clearInterval(poll); start(); }
      if (n++ > 100) clearInterval(poll);
    }, 50);
  }
})();
